import { DateStringValue } from '@mantine/dates';
import { ScheduleHeader } from '@mantine/schedule';
import dayjs from 'dayjs';
import type { EventType } from '../../types';
import { ScheduleFilterCombobox } from './components';
import {
  handleMonthChange,
  handleNextMonthClick,
  handlePreviousMonthClick,
  handleTodayClick,
  handleYearChange,
} from './helpers';

type TouringScheduleHeaderPropsType = {
  date: DateStringValue;
  setDate: (date: DateStringValue) => void;
  filter: EventType[];
  setFilter: (filter: EventType[]) => void;
};

export const TouringScheduleHeader: React.FC<
  TouringScheduleHeaderPropsType
> = ({ date, setDate, filter, setFilter }) => {
  return (
    <ScheduleHeader>
      <ScheduleHeader.Previous
        onClick={() => handlePreviousMonthClick(date, setDate)}
      />
      <ScheduleHeader.MonthYearSelect
        yearValue={dayjs(date).year()}
        monthValue={dayjs(date).month()}
        onYearChange={(year) => handleYearChange(date, setDate, year)}
        onMonthChange={(month) => handleMonthChange(date, setDate, month)}
      />
      <ScheduleHeader.Next
        onClick={() => handleNextMonthClick(date, setDate)}
      />
      <ScheduleHeader.Today onClick={() => handleTodayClick(setDate)} />
      <ScheduleFilterCombobox filter={filter} setFilter={setFilter} />
    </ScheduleHeader>
  );
};
